import { CampfireRichEditor } from '@campfire/campfire-rich-editor';
import { Cake, CakeContent } from '@campfire/cake';
import { TabletButton } from '@campfire/tablet-button';
import { Box } from '@material-ui/core';
import { convertFromRaw, EditorState } from 'draft-js';
import React, { useMemo } from 'react';
import ReactPlayer from 'react-player/lazy';
import { SUYPTaskScaffold } from './SUYPTaskScaffold';

function cleanVideoUrl(url: string): string | null {
  try {
    const parsed = new URL(url);
    if (parsed.hostname.includes('youtube.com') || parsed.hostname.includes('youtu.be')) {
      const videoId = parsed.hostname.includes('youtu.be') ? parsed.pathname.slice(1) : parsed.searchParams.get('v');
      return videoId ? `https://www.youtube.com/watch?v=${videoId}` : null;
    }
    if (parsed.hostname.includes('vimeo.com')) {
      const videoId = parsed.pathname
        .split('/')
        .filter(Boolean)
        .pop();
      return videoId ? `https://vimeo.com/${videoId}` : null;
    }
    return url;
  } catch {
    return null;
  }
}

interface SUYPPreApplicationContentProps {
  content: string | null;
  videoUrl: string | null;
  onContinue: () => void;
}

export const SUYPPreApplicationContent = ({ content, videoUrl, onContinue }: SUYPPreApplicationContentProps) => {
  const cleanedVideoUrl = useMemo(() => (videoUrl ? cleanVideoUrl(videoUrl) : null), [videoUrl]);

  const editorState = useMemo(() => {
    if (!content) return null;
    try {
      return EditorState.createWithContent(convertFromRaw(JSON.parse(content)));
    } catch {
      return null;
    }
  }, [content]);

  return (
    <Box bgcolor='#f1f1f1' display='flex' flex='1 1 auto' flexDirection='column' width={1} paddingTop={2}>
      <SUYPTaskScaffold allowBack={false} taskHeaderDetails={{ title: 'Welcome', description: '' }}>
        <Box width={1} display='flex' justifyContent='center'>
          <Box width={1} maxWidth={720} marginBottom={3}>
            <Cake>
              <CakeContent style={{ padding: '24px 30px' }}>
                {editorState && (
                  <Box marginBottom={videoUrl ? 3 : 0}>
                    <CampfireRichEditor editorState={editorState} readOnly />
                  </Box>
                )}

                {cleanedVideoUrl && (
                  <Box>
                    <ReactPlayer url={cleanedVideoUrl} width='100%' maxWidth='100%' controls />
                  </Box>
                )}
              </CakeContent>
            </Cake>

            <Box display='flex' justifyContent='flex-end' marginTop={3}>
              <TabletButton
                variant='contained'
                color='primary'
                size='large'
                onClick={onContinue}
                style={{ paddingLeft: 48, paddingRight: 48 }}
              >
                Continue
              </TabletButton>
            </Box>
          </Box>
        </Box>
      </SUYPTaskScaffold>
    </Box>
  );
};
